import { Component } from 'preact'
import $ from 'jquery'
import Header from '../header'
import Robots from './Robots'
import AlertComponent from '../ui-components/Alert'

class Seo extends Component {
  constructor () {
    super()
    this.state = {
      robots: ''
    }
    this.endpoints = {
      getData: '/seo/getRobots',
      saveData: '/seo/updateRobots'
    }
    this.onRobotTextChanged = this.onRobotTextChanged.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onRobotTextChanged (value) {
    this.setState({ robots: value })
  }

  onSave (xhr = new window.XMLHttpRequest()) {
    xhr.onreadystatechange = (evt) => {
      if (xhr.readyState === 4) {
        if (evt.target.status >= 200 && evt.target.status < 400) {
          this.props.successCallback()
        } else {
          this.props.errorCallback()
        }
      }
    }
    xhr.open('POST', this.endpoints.saveData, true)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.setRequestHeader('X-Csrf-Token', document.getElementById('csrftoken').value)
    xhr.send(JSON.stringify({
      robots: this.state.robots
    }))
  }

  componentDidMount () {
    $.get(this.endpoints.getData).then(function (data) {
      this.setState({ robots: data.robots })
    }.bind(this))
  }

  render (props, state) {
    return (
      <div>
        <Header title={'Robots.txt'} saveCallback={this.onSave} />
        {props.alertComponent}
        <Robots data={this.state.robots} onChange={this.onRobotTextChanged} />
      </div>
    )
  }
}

export { Seo }
export default (props) => <AlertComponent {...props} component={Seo} />
